import { fork, call, takeEvery, put, select } from 'redux-saga/effects';

import { actionCreators as layoutActionCreators } from '../reducers/Layout';
import { selectors as authSelectors } from '../reducers/Auth';
import Api from '../api';
import { IRootState } from '.';
import { replace } from 'connected-react-router';

// Store
// export interface ILeaseClauseState {
//     clauses: Array<LeaseClauseModel>;
// }

// const initialState: ILeaseClauseState = {
//     clauses: undefined,
// };

// Action Types
export enum actionTypes {
    CLONE_DATA = '[clone] CLONE_DATA',
}

// Action Creator
export const actionCreators = {
    cloneData: (context: string, options: string) => {
        return { type: actionTypes.CLONE_DATA, payload: { context, options } };
    },
};

// Reducer
// const reducer: Reducer<ILeaseClauseState> = (state: ILeaseClauseState = initialState, action: Action): ILeaseClauseState => {
//     switch (action.type) {
//         case actionTypes.GET_LEASE_CLAUSES_SUCCESS:
//             const getLeaseClausesPayload = (action as { type: string, payload: Array<LeaseClauseModel> }).payload;
//             return {
//                 ...state,
//                 clauses: getLeaseClausesPayload
//             };
//         default:
//             return state;
//     }
// };

// export default reducer;

// Sagas
const sagas = {
    cloneData: function* (action: { type: string; payload: { context: string; options: string } }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        yield call(Api.Clone.clone, action.payload.context, action.payload.options, jwt);
        yield put(layoutActionCreators.hideDialog());
        const path = yield select((store: IRootState) => store.router.location.pathname);
        yield put(replace('/'));
        yield put(replace(path));
    },
};

// Watches
const watches = {
    cloneData: function* () {
        yield takeEvery(actionTypes.CLONE_DATA, sagas.cloneData);
    },
};

// Forks
export function* saga() {
    yield fork(watches.cloneData);
}



// WEBPACK FOOTER //
// ./src/reducers/Clone.ts